<template>
  <div>
    <!-- 套票统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>套票统计</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v, i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex === i ? 'activeTab' : ''"
      >
        {{ v.name }}
      </span>
    </div>

    <!-- 过滤条件 -->
    <div class="title_box">
      <span>日期：</span>
      <el-date-picker
        v-model="filters.Times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-select
        v-model="filters.DistributorID"
        clearable
        filterable
        placeholder="全部分销商"
      >
        <el-option
          v-for="item in disoption"
          :key="item.DistrbutorID"
          :label="item.Name"
          :value="item.DistrbutorID"
        ></el-option>
      </el-select>
      <span>展示内容：</span>
      <el-select
        v-model="filters.type"
        placeholder="每日"
        @change="onTypeChange"
      >
        <el-option
          v-for="item in option"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="filters.ProductID"
        clearable
        filterable
        placeholder="全部产品"
        v-if="filters.type === '2'"
      >
        <el-option
          v-for="item in proDuctOption"
          :key="item.ProductID"
          :label="item.ProductName"
          :value="item.ProductID"
        ></el-option>
      </el-select>
      <div class="chaxuns" @click="onSearch">查询</div>
      <div class="chaxuns" style="margin-left:2rem;" @click="onExport">去导出</div>
      <div class="chaxuns" style="margin-left:2rem;" @click="detailsClick">查询明细</div>
    </div>

    <!-- 顶部统计卡片 -->
    <div class="statistics">
      <div v-for="(item, index) in summaryCards" :key="index">
        <div class="tics_title">
          <span>{{ item.text }}</span>
          <span>{{ item.desc }}</span>
        </div>
        <div class="tics_imgs">
          <div>
            <span>{{ item.num }}</span>
            <span>{{ item.suffix }}</span>
          </div>
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <el-card class="conentBox">
      <!-- 退票统计 -->
      <div v-if="activeIndex === 0">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column label="序号" type="index" />
          <el-table-column
            v-if="filters.type === '2'"
            prop="ProductName"
            label="产品名称"
          />
          <el-table-column
            v-if="filters.type === '1'"
            prop="UseTime"
            label="退票时间"
          />
          <el-table-column prop="total_Price" label="退票总金额" />
          <el-table-column prop="total_use" label="退票数量" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="openRefundDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{ pagination.total }}条记录，</span>
          <span class="demonstration">当前显示第{{ pagination.page }}页</span>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.page_size"
            :current-page="pagination.page"
            @current-change="onPageChange"
          />
        </div>
      </div>

      <!-- 核销统计 -->
      <div v-else-if="activeIndex === 1">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column label="序号" type="index" />
          <el-table-column
            v-if="filters.type === '2'"
            prop="ProductName"
            label="产品名称"
          />
          <el-table-column
            v-if="filters.type === '1'"
            prop="UseTime"
            label="核销时间"
          />
          <el-table-column prop="total_Price" label="金额" />
          <el-table-column prop="total_use" label="数量" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="openVerifyDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{ pagination.total }}条记录，</span>
          <span class="demonstration">当前显示第{{ pagination.page }}页</span>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.page_size"
            :current-page="pagination.page"
            @current-change="onPageChange"
          />
        </div>
      </div>

      <!-- 销售统计 -->
      <div v-else-if="activeIndex === 2">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column label="序号" type="index" />
          <el-table-column
            v-if="filters.type === '2'"
            prop="product_name"
            label="产品名称"
          />
          <el-table-column
            v-if="filters.type === '2'"
            prop="distributor_name"
            label="分销商名称"
          />
          <el-table-column
            v-if="filters.type === '1'"
            prop="CreateTime"
            label="销售时间"
          >
            <template slot-scope="scope">
              {{ scope.row.CreateTime ? scope.row.CreateTime.substr(0, 10) : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="销售额" />
          <el-table-column prop="Count" label="数量" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="openSaleDetail(scope.row)">
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{ pagination.total }}条记录，</span>
          <span class="demonstration">当前显示第{{ pagination.page }}页</span>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pagination.total"
            :page-size="pagination.page_size"
            :current-page="pagination.page"
            @current-change="onPageChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 销售统计明细弹窗（参考分销统计） -->
    <el-dialog
      title="销售统计明细"
      :visible.sync="saleDetailVisible"
      width="85%"
      :close-on-click-modal="false"
      :before-close="onSaleDetailClose"
    >
      <el-divider></el-divider>
      <div class="titleXstj">
        <el-date-picker
          v-model="saleDetailTimes"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          v-model="saleDetailForm.DistributorID"
          filterable
          clearable
          placeholder="请选择分销商"
        >
          <el-option
            v-for="item in disoption"
            :key="item.DistrbutorID"
            :label="item.Name"
            :value="item.DistrbutorID"
          ></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select
          v-model="saleDetailForm.ProductID"
          filterable
          clearable
          placeholder="请选择产品"
        >
          <el-option
            v-for="item in proDuctOption"
            :key="item.ProductID"
            :label="item.ProductName"
            :value="item.ProductID"
          ></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-input
          v-model="saleDetailForm.OrderNumber"
          placeholder="请输入订单号"
        ></el-input>
        <div style="margin:0 1rem;"></div>
        <el-input
          v-model="saleDetailForm.Mobile"
          placeholder="请输入手机号"
        ></el-input>
        <el-button @click="onSaleDetailSearch">查询</el-button>
        <el-button class="Dcb" @click="onSaleDetailExport">去导出</el-button>
      </div>
      <div class="sale-detail-table-wrap">
        <el-table
          :data="saleDetailData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="min-width: 1400px; width: 100%"
          v-loading="saleDetailLoading"
        >
          <el-table-column label="序号" type="index" width="50" />
          <el-table-column prop="OrderNumber" label="订单编号" width="125" />
          <el-table-column prop="OrderCode" label="消费码" width="100" />
          <el-table-column prop="product_name" label="产品名称" width="125" />
          <el-table-column prop="scenic_name" label="景区名称" width="85" />
          <el-table-column prop="Distributor_name" label="分销商" width="85" />
          <el-table-column prop="ActFee" label="支付金额" width="78" />
          <el-table-column prop="Mobile" label="手机号" width="110" />
          <el-table-column prop="CreateTime" label="下单时间" width="148" />
          <el-table-column prop="Count" label="数量" width="52" />
          <el-table-column prop="UseCount" label="使用数量" width="82" />
          <el-table-column prop="CancleCount" label="退款数量" width="82" />
          <el-table-column label="子产品详情" min-width="320">
          <template slot-scope="scope">
            <div v-if="scope.row.product_son && scope.row.product_son.length">
              <div
                v-for="(son, idx) in scope.row.product_son"
                :key="idx"
                class="son-row"
              >
                <span class="son-name">{{ son.product_son_name }}</span>
                <span class="son-count" style="flex: 0 0 20%;">购买数量：{{ son.Count }}</span>
                <span class="son-use" style="flex: 0 0 20%;">使用数量：{{ son.CountUse }}</span>
                <span class="son-cancle" style="flex: 0 0 20%;">退票数量：{{ son.CancleCount }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{ saleDetailPage.total }}条记录，</span>
        <span class="demonstration">当前显示第{{ saleDetailPage.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="saleDetailPage.total"
          :page-size="saleDetailPage.page_size"
          :current-page="saleDetailPage.page"
          @current-change="onSaleDetailPageChange"
        />
      </div>
    </el-dialog>

    <!-- 退票统计明细弹窗 -->
    <el-dialog
      title="退票统计明细"
      :visible.sync="refundDetailVisible"
      width="85%"
      :close-on-click-modal="false"
      :before-close="onRefundDetailClose"
    >
      <el-divider></el-divider>
      <div class="titleXstj">
        <el-date-picker
          v-model="refundDetailTimes"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select v-model="refundDetailForm.DistributorID" filterable clearable placeholder="请选择分销商">
          <el-option v-for="item in disoption" :key="item.DistrbutorID" :label="item.Name" :value="item.DistrbutorID"></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-model="refundDetailForm.ProductID" filterable clearable placeholder="请选择产品">
          <el-option v-for="item in proDuctOption" :key="item.ProductID" :label="item.ProductName" :value="item.ProductID"></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-input v-model="refundDetailForm.ordernumber" placeholder="请输入订单号"></el-input>
        <el-button @click="onRefundDetailSearch">查询</el-button>
        <el-button class="Dcb" @click="openRefundDetailExportDialog">去导出</el-button>
      </div>
      <el-table :data="refundDetailData" :header-cell-style="tableHeaderColor" :cell-style="cellStyle" style="width: 100%" v-loading="refundDetailLoading">
        <el-table-column label="序号" type="index" />
        <el-table-column prop="ProductName" label="产品名称" />
        <el-table-column prop="OrdernNmber" label="订单号" />
        <el-table-column prop="UseTime" label="时间" />
        <el-table-column prop="Use" label="数量" />
        <el-table-column prop="CountPrice" label="销售额" />
        <el-table-column label="子产品详情" width="380">
          <template slot-scope="scope">
            <div v-if="scope.row.product_son && scope.row.product_son.length">
              <div
                v-for="(son, idx) in scope.row.product_son"
                :key="idx"
                class="son-row"
              >
                <span class="son-name">{{ son.productname_son }}</span>
                <span class="son-count">购买数量：{{ son.Count }}</span>
                <span class="son-cancle">退票数量：{{ son.CancleCount }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="demonstration">共{{ refundDetailPage.total }}条记录，</span>
        <span class="demonstration">当前显示第{{ refundDetailPage.page }}页</span>
        <el-pagination background layout="prev, pager, next" :total="refundDetailPage.total" :page-size="refundDetailPage.page_size" :current-page="refundDetailPage.page" @current-change="onRefundDetailPageChange" />
      </div>
    </el-dialog>

    <!-- 核销统计明细弹窗 -->
    <el-dialog
      title="核销统计明细"
      :visible.sync="verifyDetailVisible"
      width="85%"
      :close-on-click-modal="false"
      :before-close="onVerifyDetailClose"
    >
      <el-divider></el-divider>
      <div class="titleXstj">
        <el-date-picker
          v-model="verifyDetailTimes"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select v-model="verifyDetailForm.DistributorID" filterable clearable placeholder="请选择分销商">
          <el-option v-for="item in disoption" :key="item.DistrbutorID" :label="item.Name" :value="item.DistrbutorID"></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-select v-model="verifyDetailForm.ProductID" filterable clearable placeholder="请选择产品">
          <el-option v-for="item in proDuctOption" :key="item.ProductID" :label="item.ProductName" :value="item.ProductID"></el-option>
        </el-select>
        <div style="margin:0 1rem;"></div>
        <el-input v-model="verifyDetailForm.ordernumber" placeholder="请输入订单号"></el-input>
        <el-button @click="onVerifyDetailSearch">查询</el-button>
        <el-button class="Dcb" @click="openVerifyDetailExportDialog">去导出</el-button>
      </div>
      <el-table :data="verifyDetailData" :header-cell-style="tableHeaderColor" :cell-style="cellStyle" style="width: 100%" v-loading="verifyDetailLoading">
        <el-table-column label="序号" type="index" />
        <el-table-column prop="ProductName" label="产品名称" />
        <el-table-column prop="OrdernNmber" label="订单号" />
        <el-table-column prop="CountPrice" label="金额" />
        <el-table-column prop="Use" label="验票数量" />
        <el-table-column label="验票来源">
          <template slot-scope="scope">{{ scope.row.from == '1' ? '雪务通后台' : scope.row.from == '2' ? '内管' : scope.row.from == '3' ? '自助机' : scope.row.from == '7' ? '验票小程序' : '' }}</template>
        </el-table-column>
        <el-table-column prop="username" label="验票人" />
        <el-table-column prop="UseTime" label="验票时间" />
        <el-table-column label="子产品详情" width="380">
          <template slot-scope="scope">
            <div v-if="scope.row.product_son && scope.row.product_son.length">
              <div
                v-for="(son, idx) in scope.row.product_son"
                :key="idx"
                class="son-row"
              >
                <span class="son-name">{{ son.productname_son }}</span>
                <span class="son-count">购买数量：{{ son.Count }}</span>
                <span class="son-cancle">退票数量：{{ son.CancleCount }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="demonstration">共{{ verifyDetailPage.total }}条记录，</span>
        <span class="demonstration">当前显示第{{ verifyDetailPage.page }}页</span>
        <el-pagination background layout="prev, pager, next" :total="verifyDetailPage.total" :page-size="verifyDetailPage.page_size" :current-page="verifyDetailPage.page" @current-change="onVerifyDetailPageChange" />
      </div>
    </el-dialog>

    <!-- 导出确认弹窗（带 is_wx：退票明细/核销明细） -->
    <el-dialog
      :title="exportConfirmType === 'refund' ? '退票明细导出' : '核销明细导出'"
      :visible.sync="exportConfirmVisible"
      width="480px"
      append-to-body
    >
      <div class="export-confirm-body">
        <div class="export-confirm-label">筛选条件：</div>
        <div class="export-confirm-row">
          <span class="export-confirm-item">日期：</span>
          <span>{{ exportConfirmTimesText }}</span>
        </div>
        <div class="export-confirm-row">
          <span class="export-confirm-item">分销商：</span>
          <span>{{ exportConfirmDistributorText }}</span>
        </div>
        <div class="export-confirm-row">
          <span class="export-confirm-item">产品：</span>
          <span>{{ exportConfirmProductText }}</span>
        </div>
        <div class="export-confirm-row">
          <span class="export-confirm-item">订单号：</span>
          <span>{{ exportConfirmOrderText }}</span>
        </div>
        <div class="export-confirm-row">
          <span class="export-confirm-item">是否显示微信交易单号：</span>
          <el-select v-model="exportConfirmIsWx" placeholder="请选择" size="small" style="width:120px;">
            <el-option v-for="item in isWxOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExportWithIsWx">确定导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  ComDistributorIDTotalSales,
  ComScenicDisSellTJ,
  ComScenicDisSellOneTJ,
  ComgetScenicOrderListNew,
  ComScenicDisSellOneExport,
  ComexportDistributorSalesStatistics,
  ComScenicPostExport,
  ScenicDisRefundTJXQ,
  ComDisProductRefundTotal,
  ComScenicDisRefundTJ,
  ComDistributorRefundGeneralLedger,
  ComDisProductRefundExport,
  DistributorIDRefundDateExport,
  RefundTJXQExport,
  DistributorIDVerifiGeneralLedger,
  ComScenicDisTicketTJXQ,
  ComScenicDisTicketTJ,
  ComDisProductVerifiTotal,
  ComScenicDisTicketTJExport,
  ComDisProductVerifiExport,
  ScenicDisTicketTJXQExport
} from '@/request/combo.js'
import {
  GetScenicList,
  getScenicListDistrbutor
} from '@/request/scenic.js'

export default {
  data() {
    return {
      tabBtn: [
        { id: 1, name: '退票统计' },
        { id: 2, name: '核销统计' },
        { id: 3, name: '销售统计' }
      ],
      activeIndex: 0,
      filters: {
        Times: [],
        DistributorID: '',
        ProductID: '',
        type: '1'
      },
      option: [
        { value: '1', label: '每日' },
        { value: '2', label: '产品' }
      ],
      summaryCards: [
        {
          text: '总数量',
          desc: '',
          num: 0,
          suffix: '单',
          img: require('../../../images/report/table.png')
        },
        {
          text: '总金额',
          desc: '',
          num: 0,
          suffix: '元',
          img: require('../../../images/report/money.png')
        }
      ],
      proDuctOption: [],
      disoption: [
        {
          DistrbutorID: 'a',
          Name: '景区直销'
        }
      ],
      tableData: [],
      pagination: {
        page: 1,
        page_size: 10,
        total: 0
      },
      loading: false,
      // 销售详情
      saleDetailVisible: false,
      saleDetailLoading: false,
      saleDetailData: [],
      saleDetailPage: {
        page: 1,
        page_size: 8,
        total: 0
      },
      saleDetailTimes: [],
      saleDetailForm: {
        DistributorID: '',
        ProductID: '',
        OrderNumber: '',
        Mobile: ''
      },
      // 退票详情弹窗
      refundDetailVisible: false,
      refundDetailLoading: false,
      refundDetailData: [],
      refundDetailTimes: [],
      refundDetailForm: { DistributorID: '', ProductID: '', ordernumber: '' },
      refundDetailPage: { page: 1, page_size: 8, total: 0 },
      // 核销详情弹窗
      verifyDetailVisible: false,
      verifyDetailLoading: false,
      verifyDetailData: [],
      verifyDetailTimes: [],
      verifyDetailForm: { DistributorID: '', ProductID: '', ordernumber: '' },
      verifyDetailPage: { page: 1, page_size: 8, total: 0 },
      // 导出确认弹窗（is_wx）
      exportConfirmVisible: false,
      exportConfirmType: '', // 'refund' | 'verify'
      exportConfirmIsWx: '1',
      isWxOptions: [
        { value: '1', label: '否' },
        { value: '2', label: '是' }
      ]
    }
  },
  computed: {
    exportConfirmTimesText() {
      const times = this.exportConfirmType === 'refund' ? this.refundDetailTimes : this.verifyDetailTimes
      if (!times || times.length !== 2) return '未选择'
      return `${times[0]} 至 ${times[1]}`
    },
    exportConfirmDistributorText() {
      const id = this.exportConfirmType === 'refund' ? this.refundDetailForm.DistributorID : this.verifyDetailForm.DistributorID
      if (!id) return '全部'
      const item = this.disoption.find(d => d.DistrbutorID === id)
      return item ? item.Name : id
    },
    exportConfirmProductText() {
      const id = this.exportConfirmType === 'refund' ? this.refundDetailForm.ProductID : this.verifyDetailForm.ProductID
      if (!id) return '全部'
      const item = this.proDuctOption.find(p => p.ProductID === id)
      return item ? item.ProductName : id
    },
    exportConfirmOrderText() {
      const order = this.exportConfirmType === 'refund' ? this.refundDetailForm.ordernumber : this.verifyDetailForm.ordernumber
      return order || '未填'
    }
  },
  created() {
    const today = this.GetDateStr(0)
    this.filters.Times = [today, today]
    // 初始化产品和分销商下拉选项，与分销统计保持一致
    const base = {
      token: window.sessionStorage.getItem('Token'),
      page: 1,
      page_size: 999
    }
    GetScenicList(base).then(res => {
      if (res.data && res.data.status === 'ok') {
        this.proDuctOption = res.data.result.data
      }
    })
    getScenicListDistrbutor(base).then(res => {
      if (res.data && res.data.status === 'ok') {
        this.disoption = this.disoption.concat(res.data.result.data)
      }
    })
    this.updateSummaryDesc()
    this.fetchSummary()
    this.fetchList()
  },
  methods: {
    tabTitle(index) {
      console.log('tabTitle 切换 Tab，index = ', index)
      this.activeIndex = index
      this.filters.type = '1'
      this.pagination.page = 1
      this.pagination.total = 0
      // 切换 Tab 时，统一关闭所有明细弹窗，避免之前的弹窗残留造成干扰
      this.saleDetailVisible = false
      this.refundDetailVisible = false
      this.verifyDetailVisible = false
      this.updateSummaryDesc()
      this.fetchSummary()
      this.fetchList()
    },
    updateSummaryDesc() {
      if (this.activeIndex === 0) {
        this.summaryCards[0].desc = '退票总数量'
        this.summaryCards[1].desc = '退票总金额'
      } else if (this.activeIndex === 1) {
        this.summaryCards[0].desc = '核销总数量'
        this.summaryCards[1].desc = '核销总金额'
      } else if (this.activeIndex === 2) {
        this.summaryCards[0].desc = '销售总数量'
        this.summaryCards[1].desc = '销售总金额'
      }
    },
    onSearch() {
      if (!this.filters.Times || this.filters.Times.length !== 2) {
        this.$message.error('请选择时间')
        return
      }
      this.pagination.page = 1
      this.pagination.total = 0
      this.fetchSummary()
      this.fetchList()
    },
    onTypeChange() {
      // 展示内容切换时，重置产品条件并自动刷新数据
      if (this.filters.type === '1') {
        this.filters.ProductID = ''
      }
      if (!this.filters.Times || this.filters.Times.length !== 2) {
        return
      }
      this.pagination.page = 1
      this.pagination.total = 0
      this.fetchSummary()
      this.fetchList()
    },
    onExport() {
      if (!this.filters.Times || this.filters.Times.length !== 2) {
        this.$message.error('请选择时间后导出')
        return
      }
      const base = {
        token: window.sessionStorage.getItem('Token'),
        start_date: this.filters.Times[0] + ' 00:00:00',
        end_date: this.filters.Times[1] + ' 23:59:59',
        DistributorID: this.filters.DistributorID || '',
        productid: this.filters.ProductID || '',
        ProductID: this.filters.ProductID || ''
      }
      // 退票导出
      if (this.activeIndex === 0) {
        if (this.filters.type === '1') {
          DistributorIDRefundDateExport(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        } else {
          ComDisProductRefundExport(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        }
      }
      // 核销导出
      if (this.activeIndex === 1) {
        if (this.filters.type === '1') {
          ComScenicDisTicketTJExport(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        } else {
          ComDisProductVerifiExport(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        }
      }
      // 销售导出
      if (this.activeIndex === 2) {
        if (this.filters.type === '1') {
          ComexportDistributorSalesStatistics(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        } else {
          ComScenicDisSellOneExport(base).then(res => {
            if (res.data && res.data.rcode === '200') {
              window.location.href = res.data.result
            }
          })
        }
      }
    },
    onPageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    onSaleDetailPageChange(page) {
      this.saleDetailPage.page = page
      this.fetchSaleDetail()
    },
    buildBaseParams() {
      const params = {
        token: window.sessionStorage.getItem('Token'),
        DistributorID: this.filters.DistributorID || '',
        productid: this.filters.ProductID || '',
        ProductID: this.filters.ProductID || ''
      }
      if (this.filters.Times && this.filters.Times.length === 2) {
        params.start_date = this.filters.Times[0] + ' 00:00:00'
        params.end_date = this.filters.Times[1] + ' 23:59:59'
      }
      return params
    },
    fetchSummary() {
      const params = this.buildBaseParams()
      if (!params.start_date || !params.end_date) {
        return
      }
      if (this.activeIndex === 0) {
        ComDistributorRefundGeneralLedger(params).then(res => {
          if (res.data && res.data.status === 'ok' && res.data.result && res.data.result.length) {
            const row = res.data.result[0]
            this.summaryCards[0].num = row.orderformUse || 0
            this.summaryCards[1].num = row.CountPrice || 0
          } else {
            this.summaryCards[0].num = 0
            this.summaryCards[1].num = 0
          }
        })
      } else if (this.activeIndex === 1) {
        DistributorIDVerifiGeneralLedger(params).then(res => {
          if (res.data && res.data.status === 'ok' && res.data.result && res.data.result.length) {
            const row = res.data.result[0]
            this.summaryCards[0].num = row.orderformUse || 0
            this.summaryCards[1].num = row.CountPrice || 0
          } else {
            this.summaryCards[0].num = 0
            this.summaryCards[1].num = 0
          }
        })
      } else if (this.activeIndex === 2) {
        ComDistributorIDTotalSales(params).then(res => {
          if (res.data && res.data.status === 'ok' && res.data.result && res.data.result.length) {
            const row = res.data.result[0]
            this.summaryCards[0].num = row.count || 0
            this.summaryCards[1].num = row.ActFee || 0
          } else {
            this.summaryCards[0].num = 0
            this.summaryCards[1].num = 0
          }
        })
      }
    },
    fetchList() {
      const base = this.buildBaseParams()
      if (!base.start_date || !base.end_date) {
        return
      }
      this.loading = true
      // 退票
      if (this.activeIndex === 0) {
        const params = {
          ...base,
          page_size: this.pagination.page_size,
          page: this.pagination.page
        }
        if (this.filters.type === '1') {
          ComScenicDisRefundTJ(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              this.tableData = res.data.result.data || []
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          ComDisProductRefundTotal(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              const list = res.data.result.data || []
              list.forEach(item => {
                item.total_Price = item.price
                item.total_use = item.orderformUse
              })
              this.tableData = list
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }
      // 核销
      if (this.activeIndex === 1) {
        const params = {
          ...base,
          page_size: this.pagination.page_size,
          page: this.pagination.page
        }
        if (this.filters.type === '1') {
          ComScenicDisTicketTJ(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              this.tableData = res.data.result.data || []
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          ComDisProductVerifiTotal(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              const list = res.data.result.data || []
              list.forEach(item => {
                item.total_Price = item.price
                item.total_use = item.orderformUse
              })
              this.tableData = list
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }
      // 销售
      if (this.activeIndex === 2) {
        const params = {
          ...base,
          page_size: this.pagination.page_size,
          page: this.pagination.page
        }
        if (this.filters.type === '1') {
          ComScenicDisSellTJ(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              this.tableData = res.data.result.data || []
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          ComScenicDisSellOneTJ(params).then(res => {
            this.loading = false
            if (res.data && res.data.status === 'ok') {
              this.tableData = res.data.result.data || []
              this.pagination.total = res.data.result.total || 0
            } else {
              this.tableData = []
              this.pagination.total = 0
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }
    },
    detailsClick() {
      if (!this.filters.Times || this.filters.Times.length !== 2) {
        this.$message.error('请选择时间')
        return
      }
      console.log('detailsClick 点击，activeIndex = ', this.activeIndex)
      if (this.activeIndex === 2) {
        console.log('detailsClick 分支：销售统计明细（saleDetailVisible）')
        this.saleDetailTimes = [...this.filters.Times]
        this.saleDetailVisible = true
        this.saleDetailPage.page = 1
        this.saleDetailPage.total = 0
        this.$nextTick(() => this.fetchSaleDetail())
      } else if (this.activeIndex === 0) {
        console.log('detailsClick 分支：退票统计明细（refundDetailVisible）')
        this.refundDetailTimes = [...this.filters.Times]
        this.refundDetailForm.DistributorID = this.filters.DistributorID || ''
        this.refundDetailForm.ProductID = this.filters.ProductID || ''
        this.refundDetailForm.ordernumber = ''
        this.refundDetailPage.page = 1
        this.refundDetailPage.total = 0
        this.refundDetailVisible = true
        this.$nextTick(() => this.fetchRefundDetail())
      } else if (this.activeIndex === 1) {
        console.log('detailsClick 分支：核销统计明细（verifyDetailVisible）')
        this.verifyDetailTimes = [...this.filters.Times]
        this.verifyDetailForm.DistributorID = this.filters.DistributorID || ''
        this.verifyDetailForm.ProductID = this.filters.ProductID || ''
        this.verifyDetailForm.ordernumber = ''
        this.verifyDetailPage.page = 1
        this.verifyDetailPage.total = 0
        this.verifyDetailVisible = true
        this.$nextTick(() => this.fetchVerifyDetail())
      }
    },
    openSaleDetail(row) {
      // 先设置弹窗内的时间：展示内容为“每日”时，用当前行那一天（2026-01-27 -> 2026-01-27 至 2026-01-27）
      console.log('openSaleDetail 点击，activeIndex = ', this.activeIndex, 'filters.type = ', this.filters.type)
      if (this.filters.type === '1' && row) {
        const dateStr = (row.CreateTime || '').toString().substr(0, 10)
        if (dateStr) {
          this.saleDetailTimes = [dateStr, dateStr]
        } else if (this.filters.Times && this.filters.Times.length === 2) {
          this.saleDetailTimes = [...this.filters.Times]
        }
      } else if (this.filters.Times && this.filters.Times.length === 2) {
        this.saleDetailTimes = [...this.filters.Times]
      }
      // 透传当前行的产品和分销商
      if (row && row.ProductID) {
        this.saleDetailForm.ProductID = row.ProductID
      } else if (this.filters.ProductID) {
        this.saleDetailForm.ProductID = this.filters.ProductID
      } else {
        this.saleDetailForm.ProductID = ''
      }
      if (this.filters.DistributorID) {
        this.saleDetailForm.DistributorID = this.filters.DistributorID
      } else {
        this.saleDetailForm.DistributorID = ''
      }
      // 打开销售明细前，确保其他两个明细弹窗关闭，避免显示错弹窗的情况
      this.refundDetailVisible = false
      this.verifyDetailVisible = false
      console.log('openSaleDetail 即将打开销售明细，saleDetailVisible = true')
      this.saleDetailPage.page = 1
      this.saleDetailPage.total = 0
      this.saleDetailVisible = true
      this.$nextTick(() => {
        this.fetchSaleDetail()
      })
    },
    onSaleDetailClose(done) {
      this.saleDetailTimes = []
      this.saleDetailForm = {
        DistributorID: '',
        ProductID: '',
        OrderNumber: '',
        Mobile: ''
      }
      this.saleDetailData = []
      this.saleDetailPage = { page: 1, page_size: 8, total: 0 }
      if (typeof done === 'function') done()
    },
    onSaleDetailSearch() {
      if (!this.saleDetailTimes || this.saleDetailTimes.length !== 2) {
        this.$message.error('请选择时间')
        return
      }
      this.saleDetailPage.page = 1
      this.fetchSaleDetail()
    },
    fetchSaleDetail() {
      const token = window.sessionStorage.getItem('Token')
      const times = this.saleDetailTimes && this.saleDetailTimes.length === 2
        ? this.saleDetailTimes
        : this.filters.Times
      if (!times || times.length !== 2) {
        return
      }
      const params = {
        token,
        start_date: times[0] + ' 00:00:00',
        end_date: times[1] + ' 23:59:59',
        DistributorID: this.saleDetailForm.DistributorID || this.filters.DistributorID || '',
        ProductID: this.saleDetailForm.ProductID || this.filters.ProductID || '',
        OrderNumber: this.saleDetailForm.OrderNumber || '',
        Mobile: this.saleDetailForm.Mobile || '',
        page: this.saleDetailPage.page,
        page_size: this.saleDetailPage.page_size
      }
      this.saleDetailLoading = true
      ComgetScenicOrderListNew(params).then(res => {
        this.saleDetailLoading = false
        if (res.data && res.data.status === 'ok') {
          this.saleDetailData = res.data.result.data || []
          this.saleDetailPage.total = res.data.result.total || 0
        } else {
          this.saleDetailData = []
          this.saleDetailPage.total = 0
        }
      }).catch(() => {
        this.saleDetailLoading = false
      })
    },
    onSaleDetailExport() {
      const token = window.sessionStorage.getItem('Token')
      const times = this.saleDetailTimes && this.saleDetailTimes.length === 2
        ? this.saleDetailTimes
        : this.filters.Times
      if (!times || times.length !== 2) {
        this.$message.error('请选择时间后导出')
        return
      }
      const params = {
        token,
        start_time: times[0] + ' 00:00:00',
        end_time: times[1] + ' 23:59:59',
        DistributorID: this.saleDetailForm.DistributorID || this.filters.DistributorID || '',
        Mobile: this.saleDetailForm.Mobile || '',
        OrderNumber: this.saleDetailForm.OrderNumber || ''
      }
      ComScenicPostExport(params).then(res => {
        if (res.data && res.data.rcode === '200') {
          window.location.href = res.data.result
        }
      })
    },
    openRefundDetail(row) {
      console.log('openRefundDetail 点击，activeIndex = ', this.activeIndex, 'filters.type = ', this.filters.type)
      if (this.filters.type === '1' && row && row.UseTime) {
        const day = (row.UseTime + '').substr(0, 10)
        this.refundDetailTimes = [day, day]
      } else if (this.filters.Times && this.filters.Times.length === 2) {
        this.refundDetailTimes = [...this.filters.Times]
      }
      this.refundDetailForm.DistributorID = this.filters.DistributorID || ''
      this.refundDetailForm.ProductID = (row && row.ProductID) || this.filters.ProductID || ''
      this.refundDetailForm.ordernumber = (row && row.OrdernNmber) || ''
      this.refundDetailPage.page = 1
      this.refundDetailPage.total = 0
      console.log('openRefundDetail 即将打开退票明细，refundDetailVisible = true')
      this.refundDetailVisible = true
      this.$nextTick(() => this.fetchRefundDetail())
    },
    onRefundDetailClose(done) {
      this.refundDetailTimes = []
      this.refundDetailForm = { DistributorID: '', ProductID: '', ordernumber: '' }
      this.refundDetailData = []
      this.refundDetailPage = { page: 1, page_size: 8, total: 0 }
      if (typeof done === 'function') done()
    },
    onRefundDetailSearch() {
      if (!this.refundDetailTimes || this.refundDetailTimes.length !== 2) {
        this.$message.error('请选择时间')
        return
      }
      this.refundDetailPage.page = 1
      this.fetchRefundDetail()
    },
    fetchRefundDetail() {
      const times = this.refundDetailTimes && this.refundDetailTimes.length === 2 ? this.refundDetailTimes : this.filters.Times
      if (!times || times.length !== 2) return
      const params = {
        token: window.sessionStorage.getItem('Token'),
        start_date: times[0] + ' 00:00:00',
        end_date: times[1] + ' 23:59:59',
        DistributorID: this.refundDetailForm.DistributorID || '',
        productid: this.refundDetailForm.ProductID || '',
        ordernumber: this.refundDetailForm.ordernumber || '',
        page: this.refundDetailPage.page,
        page_size: this.refundDetailPage.page_size
      }
      this.refundDetailLoading = true
      ScenicDisRefundTJXQ(params).then(res => {
        this.refundDetailLoading = false
        if (res.data && res.data.status === 'ok') {
          this.refundDetailData = res.data.result.data || []
          this.refundDetailPage.total = res.data.result.total || 0
        } else {
          this.refundDetailData = []
          this.refundDetailPage.total = 0
        }
      }).catch(() => { this.refundDetailLoading = false })
    },
    onRefundDetailPageChange(page) {
      this.refundDetailPage.page = page
      this.fetchRefundDetail()
    },
    openRefundDetailExportDialog() {
      const times = this.refundDetailTimes && this.refundDetailTimes.length === 2 ? this.refundDetailTimes : this.filters.Times
      if (!times || times.length !== 2) {
        this.$message.error('请选择时间后导出')
        return
      }
      this.exportConfirmType = 'refund'
      this.exportConfirmIsWx = '1'
      this.exportConfirmVisible = true
    },
    openVerifyDetailExportDialog() {
      const times = this.verifyDetailTimes && this.verifyDetailTimes.length === 2 ? this.verifyDetailTimes : this.filters.Times
      if (!times || times.length !== 2) {
        this.$message.error('请选择时间后导出')
        return
      }
      this.exportConfirmType = 'verify'
      this.exportConfirmIsWx = '1'
      this.exportConfirmVisible = true
    },
    confirmExportWithIsWx() {
      const times = this.exportConfirmType === 'refund'
        ? (this.refundDetailTimes && this.refundDetailTimes.length === 2 ? this.refundDetailTimes : this.filters.Times)
        : (this.verifyDetailTimes && this.verifyDetailTimes.length === 2 ? this.verifyDetailTimes : this.filters.Times)
      if (!times || times.length !== 2) {
        this.$message.error('请选择时间后导出')
        return
      }
      const base = {
        token: window.sessionStorage.getItem('Token'),
        start_date: times[0] + ' 00:00:00',
        end_date: times[1] + ' 23:59:59',
        is_wx: this.exportConfirmIsWx
      }
      if (this.exportConfirmType === 'refund') {
        Object.assign(base, {
          DistributorID: this.refundDetailForm.DistributorID || '',
          productid: this.refundDetailForm.ProductID || '',
          ordernumber: this.refundDetailForm.ordernumber || ''
        })
        RefundTJXQExport(base).then(res => {
          if (res.data && (res.data.rcode === 200 || res.data.rcode === '200')) window.location.href = res.data.result
          this.exportConfirmVisible = false
        })
      } else {
        Object.assign(base, {
          DistributorID: this.verifyDetailForm.DistributorID || '',
          productid: this.verifyDetailForm.ProductID || '',
          ordernumber: this.verifyDetailForm.ordernumber || ''
        })
        ScenicDisTicketTJXQExport(base).then(res => {
          if (res.data && (res.data.rcode === 200 || res.data.rcode === '200')) window.location.href = res.data.result
          this.exportConfirmVisible = false
        })
      }
    },
    openVerifyDetail(row) {
      console.log('openVerifyDetail 点击，activeIndex = ', this.activeIndex, 'filters.type = ', this.filters.type)
      // 理论上只会在核销统计 Tab（activeIndex === 1）下触发
      // 如果在其它 Tab 被误触发，统一按“销售查看详情”处理，避免再次打开核销弹窗
      if (this.activeIndex !== 1) {
        console.log('openVerifyDetail 在非核销 Tab 被触发，转为打开销售统计明细')
        this.openSaleDetail(row)
        return
      }
      if (this.filters.type === '1' && row && row.UseTime) {
        const day = (row.UseTime + '').substr(0, 10)
        this.verifyDetailTimes = [day, day]
      } else if (this.filters.Times && this.filters.Times.length === 2) {
        this.verifyDetailTimes = [...this.filters.Times]
      }
      this.verifyDetailForm.DistributorID = this.filters.DistributorID || ''
      this.verifyDetailForm.ProductID = (row && row.ProductID) || this.filters.ProductID || ''
      this.verifyDetailForm.ordernumber = (row && row.OrdernNmber) || ''
      this.verifyDetailPage.page = 1
      this.verifyDetailPage.total = 0
      console.log('openVerifyDetail 即将打开核销明细，verifyDetailVisible = true')
      this.verifyDetailVisible = true
      this.$nextTick(() => this.fetchVerifyDetail())
    },
    onVerifyDetailClose(done) {
      this.verifyDetailTimes = []
      this.verifyDetailForm = { DistributorID: '', ProductID: '', ordernumber: '' }
      this.verifyDetailData = []
      this.verifyDetailPage = { page: 1, page_size: 8, total: 0 }
      if (typeof done === 'function') done()
    },
    onVerifyDetailSearch() {
      if (!this.verifyDetailTimes || this.verifyDetailTimes.length !== 2) {
        this.$message.error('请选择时间')
        return
      }
      this.verifyDetailPage.page = 1
      this.fetchVerifyDetail()
    },
    fetchVerifyDetail() {
      const times = this.verifyDetailTimes && this.verifyDetailTimes.length === 2 ? this.verifyDetailTimes : this.filters.Times
      if (!times || times.length !== 2) return
      const params = {
        token: window.sessionStorage.getItem('Token'),
        start_date: times[0] + ' 00:00:00',
        end_date: times[1] + ' 23:59:59',
        DistributorID: this.verifyDetailForm.DistributorID || '',
        productid: this.verifyDetailForm.ProductID || '',
        ordernumber: this.verifyDetailForm.ordernumber || '',
        page: this.verifyDetailPage.page,
        page_size: this.verifyDetailPage.page_size
      }
      this.verifyDetailLoading = true
      ComScenicDisTicketTJXQ(params).then(res => {
        this.verifyDetailLoading = false
        if (res.data && res.data.status === 'ok') {
          this.verifyDetailData = res.data.result.data || []
          this.verifyDetailPage.total = res.data.result.total || 0
        } else {
          this.verifyDetailData = []
          this.verifyDetailPage.total = 0
        }
      }).catch(() => { this.verifyDetailLoading = false })
    },
    onVerifyDetailPageChange(page) {
      this.verifyDetailPage.page = page
      this.fetchVerifyDetail()
    },
    // 表头样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      })
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      })
    },
    GetDateStr(AddDayCount) {
      const dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount)
      const y = dd.getFullYear()
      let m = dd.getMonth() + 1
      let d = dd.getDate()
      m = m > 9 ? m : '0' + m
      d = d > 9 ? d : '0' + d
      return y + '-' + m + '-' + d
    }
  }
}
</script>

<style lang='less' scoped>
.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    cursor: pointer;
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
.title_box{
  width: 100%;
  background: #fff;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /deep/.el-select{
    margin-right: 1rem;
    width:22rem;
  }
  /deep/.el-date-editor{
    margin-right: 2rem;
    width:28rem;
  }
  span{
    color: #666;
  }
}
.chaxuns{
  width: 10rem;
  height: 4rem;
  border-radius: 0.4rem;
  background: #246DEB;
  color: #fff;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.statistics{
  margin: 2rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  >div{
    position: relative;
    width: 39rem;
    height: 15rem;
    border-radius: 0.4rem;
    background: #fff;
    margin-right: 2rem;
    padding: 1.7rem 2rem;
    box-sizing: border-box;
    .tics_title{
      display: flex;
      align-items: center;
      span{
        color: #333;
        font-size: 1.4rem;
        &:nth-child(1){
          font-family: OPPOSans;
        }
        &:nth-child(2){
          color: #666666;
          margin-left: 0.3rem;
        }
      }
    }
    .tics_imgs{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 3.7rem;
      img{
        width: 5.4rem;
        height: 6rem;
      }
      div{
         span{
          color: #246DEB;
          font-size: 4rem;
          &:nth-child(1){
            font-family: OPPOSans;
          }
          &:last-child{
            color: #797979;
            font-size: 2rem;
            margin-left: 0.9rem;
          }
         }
      }
    }
  }
}
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  .conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    >div{
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      ::v-deep .el-button{
        height: 4rem;
        margin-left: 2rem;
        background: #246DEB;
        color: #fff;
      }
      
    }
  }
}
.txts{
  margin-bottom: 2rem;
  color: red;
  font-size: 1.6rem;
}
.clssColor{
  background: #F7F7FA;
  // margin-left: 22.2rem;
}
.posmmm{
  position: relative;
  span{
    display: block;
    position: absolute;
    top: -30%;
    transform: translate(0,-50%);
  }
}
.son-row{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 2;
  font-size: 14px;
  margin: 2px 0;
}
.son-row .son-name{
  flex: 0 0 35%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.son-row .son-count,
.son-row .son-use,
.son-row .son-cancle{
  flex: 0 0 25%;
  text-align: left;
  margin-left: 0.8rem;
  color: #666;
}
.son-row .son-cancle {
  margin-left: 1.2rem;
}
.sale-detail-table-wrap {
  overflow-x: auto;
  margin-bottom: 16px;
}
.titleXstj {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: nowrap;
  .el-input {
    width: 250px;
    margin-bottom: 1rem;
  }
  .el-select {
    margin-bottom: 1rem;
    width: 220px;
  }
  /deep/.el-date-editor {
    margin-bottom: 1rem !important;
    margin: 0 20px;
  }
  .el-button {
    margin-bottom: 1rem;
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-left: 20px;
  }
  .Dcb {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    margin-bottom: 1rem;
    margin-left: 20px;
  }
}
.export-confirm-body {
  padding: 8px 0;
}
.export-confirm-label {
  font-weight: 500;
  margin-bottom: 12px;
  color: #303133;
}
.export-confirm-row {
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}
.export-confirm-item {
  display: inline-block;
  width: 160px;
  color: #909399;
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}
/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}
/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}
/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>
